import './GISMap.css';

import { Loading } from '@dsi/react-eds';
import React, { useEffect } from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';

import useCustomerData from '../../Context/CustomerDataContext';
import useMapData from '../../Context/MapDataContext';
import useGISNodes from '../../hooks/useGISNodes';
import { useGlobalFilterData } from '../../hooks/useGlobalFilterData';
import {
  getRegionsString,
  getSitesString,
  getCirclesString,
  getCitiesString
} from '../../utils/functionUtils';
import ShowSites from './ShowSites';

const GISMap = (props) => {
  const { zoom, mapCenter } = useMapData();

  const indiaBounds = [
    [6.554607, 68.111378], 
    [35.674545, 97.395561],
  ];

  const { customer } = useCustomerData();
  // const { mutate, data: sites, isLoading, isError, error } = useGISNodes(customer);

  const {
    startDate,
    endDate,
    selectedRegions,
    selectedCircles,
    selectedCities,
    selectedSites
  } = useGlobalFilterData();

  // useEffect(() => {
  //   let body = {};

  //   if (selectedRegions && selectedRegions.length > 0) {
  //     body.regions = getRegionsString(selectedRegions);
  //   }

  //   if (selectedCircles && selectedCircles.length > 0) {
  //     body.circles = getCirclesString(selectedCircles);
  //   }

  //   if (selectedCities && selectedCities.length > 0) {
  //     body.cities = getCitiesString(selectedCities);
  //   }

  //   if (selectedSites && selectedSites.length > 0) {
  //     body.sites = getSitesString(selectedSites);
  //   }

  //   body.toTime = endDate;
  //   body.fromTime = startDate;
  //   body.page = 1;

  //   mutate(body);
  // }, [startDate, selectedRegions, selectedSites, mutate, endDate]);

  const handleNodeClick = (node) => {
    // setSelectedSite(node);
  };

  const closeNodeDetails = () => {
    // setSelectedSite(null);
  };

  if (props.isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        {/* <Loading size="medium" /> */}
      </div>
    );
  } else if (props.isError) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <p>
          {props.error?.message ? props.error?.message : 'Something went wrong please try again.'}
        </p>
      </div>
    );
  } else {
    return (
      <MapContainer
        center={mapCenter}
        // center={[22.5937, 78.9629]}
        // center={[-2.5489, 118.0149]}
        zoom={props.fullZoom ? props.fullZoom : zoom}
        scrollWheelZoom={true}
        style={{ flex: 1 }}
        maxBounds={indiaBounds} 
        maxBoundsViscosity={1.0}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ShowSites
          data={props.data}
          handleNodeClick={handleNodeClick}
        />
      </MapContainer>
    );
  }
};

export default React.memo(GISMap);
